module.exports = __webpack_public_path__ + "img/nottingham-forest-logo-icon.3ff6d5e4.png";